<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>學習紀錄</v-toolbar-title>
    </v-toolbar>
    <v-data-table
        v-bind:headers="headers"
        v-model="items"
        v-bind:search="search"
        hide-actions
        class="elevation-1"
        no-data-text="目前無可用資料"
        style="background-color: #fff;"
      >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.cityAreaName }}</td>
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.time }}</td>
      </template>
    </v-data-table>

    <div class="mt-3" style="text-align: center;">
      <v-pagination v-bind:length.number="pageCount" v-model="page" />
    </div>
  </div>
</template>

<script>
  import api from '../api'

  export default {

    name: 'LearningRecord',

    data () {
      return {
        search: '',
        headers: [
          {
            text: '區域',
            left: true,
            sortable: true,
            value: 'cityAreaName'
          },
          {
            text: '名稱',
            left: true,
            value: 'name',
            sortable: true
          },
          {
            text: '時間',
            sortable: true,
            value: 'time'
          }
        ],
        items: [],
        page: 1,
        pageCount: 0
      }
    },

    created () {
      this.getData()
      this.$watch('page', () => {
        this.getData()
      })
    },

    methods: {
      getData () {
        let self = this
        api.Learning
          .Record(this.page, 20)
          .then((res) => {
            self.pageCount = res.data.PageCount
            self.items = []
            res.data.data
            .forEach((el) => {
              self.items.push({
                cityAreaName: el.cityAreaName,
                name: el.name,
                time: el.spendTime
              })
            })
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LearningRecord.vue?36a60365